import type { App } from 'vue';
import { createI18n } from 'vue-i18n';
import zhCN from '@/i18n/zh';
import enUS from '@/i18n/en';
import { LanguageEnum } from '@/enums/appEnum';

const messages = {
  [LanguageEnum.ZH]: zhCN,
  [LanguageEnum.EN]: enUS
};

/**
 * 创建 i18n 实例
 */
export const i18n = createI18n({
  legacy: false,
  // 直接从 localStorage 读取语言，避免与工具函数产生循环依赖
  locale: (typeof window !== 'undefined' && window.localStorage.getItem('locale')) || LanguageEnum.EN,
  fallbackLocale: LanguageEnum.ZH,
  messages
});

/**
 * i18n 插件
 * @param app Vue应用实例
 */
export function setupI18n(app: App) {
  app.use(i18n);
}
